import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSupplierOrders } from '../api/apiendpoint'; // secure endpoint
import { useAuth } from '../context/AuthContext'; // optional, for access control

const SupplierOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [notifications, setNotifications] = useState(0);
  const navigate = useNavigate();
  const { user } = useAuth(); // assumes user info is stored here

  useEffect(() => {
    // Redirect non-admin users
    if (user && !user.is_staff) {
      navigate('/unauthorized'); // or navigate('/login') or homepage
    }
  }, [user, navigate]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await getSupplierOrders();
        setOrders(data);
        setNotifications(data.length);
      } catch (err) {
        console.error('Failed to fetch supplier orders:', err);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Supplier Dashboard</h2>
        <span className="badge bg-primary">New Orders: {notifications}</span>
      </div>

      {orders.length === 0 ? (
        <p>No orders available.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Customer</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Items</th>
                <th>Subtotal</th>
                <th>Delivery</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => {
                const total = parseFloat(order.subtotal) + parseFloat(order.delivery_fee);
                return (
                  <tr key={order.id}>
                    <td>{index + 1}</td>
                    <td>{order.customer_name}</td>
                    <td>{order.phone_number}</td>
                    <td>{order.address}</td>
                    <td>
                      <ul className="list-unstyled">
                        {order.orderitem_set.map((item) => (
                          <li key={item.id}>
                            {item.name} — {item.quantity} pcs @ ${item.price}
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td>${order.subtotal}</td>
                    <td>${order.delivery_fee}</td>
                    <td><strong>${total.toFixed(2)}</strong></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SupplierOrdersPage;
